import { render, staticRenderFns } from "./OrgUsersDivisions.vue?vue&type=template&id=405c73e3&scoped=true&"
import script from "./OrgUsersDivisions.vue?vue&type=script&lang=js&"
export * from "./OrgUsersDivisions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405c73e3",
  null
  
)

export default component.exports